import { createI18n } from 'vue-i18n'
import ja from './locales/ja.json'
import en from './locales/en.json'

// デフォルト言語の判定（localStorage -> ブラウザ設定 -> 'ja'）
function getDefaultLocale() {
  const saved = localStorage.getItem('user_locale')
  if (saved && (saved === 'ja' || saved === 'en')) {
    return saved
  }
  const browserLang = (navigator.language || navigator.userLanguage || '').toLowerCase()
  if (browserLang.startsWith('ja')) {
    return 'ja'
  }
  // 日本語以外はデフォルト英語
  return 'en'
}

const defaultLocale = getDefaultLocale()

const i18n = createI18n({
  legacy: true, // Options API (this.$t, this.$i18n) で動作
  locale: defaultLocale,
  fallbackLocale: 'ja',
  messages: {
    ja,
    en
  }
})

// 言語切り替えヘルパー
export function setLocale(locale) {
  if (locale === 'ja' || locale === 'en') {
    i18n.global.locale = locale
    localStorage.setItem('user_locale', locale)
    document.documentElement.setAttribute('lang', locale)
    // イベントを発行してコンポーネントが検知できるようにする
    window.dispatchEvent(new CustomEvent('locale-changed', { detail: { locale } }))
  }
}

export function getLocale() {
  return i18n.global.locale
}

export default i18n
